<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions__left"></div>
				<div class="sf-actions__right">
					<!--신규 -->
					<sf-button size="sm" line icon="file" v-if="isButton_(scrId, 'CU')" :onClick="newAction">
						{{ getMessage_('QWCC001083') }}
					</sf-button>
					<!--저장 -->
					<sf-button size="sm" line icon="file" v-if="isButton_(scrId, 'CU')" :onClick="saveAction">
						{{ getMessage_('QWCC001131') }}
					</sf-button>
				</div>
			</div>
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--업체구분-->
							<th class="col-1">* {{ getMessage_('QWCC001108') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:placeholder="this.getMessage_('QWCC001108')"
									:inputValue="masterInfo.cpnyScn"
									:onChange="val => onChangeSelect(val, 'cpnyScn')"
									:options="cpnyScnList"
									:disabled="masterInfo.readOnlyAuth"
								/>
								<!-- <el-input :value="masterInfo.cpnyScn" :readonly="masterInfo.readOnlyAuth" /> -->
							</td>
							<!--업체코드-->
							<th class="col-1">* {{ getMessage_('QWCC000950') }}</th>
							<td class="col-1">
								<el-input :value="masterInfo.cpnyCd" :readonly="masterInfo.readOnlyAuth" @input="val => onChangeSelect(val, 'cpnyCd')" />
							</td>
							<!--업체명-->
							<th class="col-1">{{ getMessage_('QWCC000951') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input :value="masterInfo.cpnyNm" maxlength="100" @input="val => onChangeSelect(val, 'cpnyNm')"></el-input>
										</div>
									</el-col>
								</div>
							</td>
							<!--부품유형-->
							<th class="col-1">* {{ getMessage_('QWCC000059') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:placeholder="this.getMessage_('QWCC000059')"
									:inputValue="masterInfo.partType"
									:onChange="val => onChangeSelect(val, 'partType')"
									:options="PartTypeList"
								/>
							</td>

							<!--사용여부-->
							<th class="col-1">* {{ getMessage_('QWCC001163') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:placeholder="this.getMessage_('QWCC001163')"
									:inputValue="masterInfo.useYn"
									:onChange="val => onChangeSelect(val, 'useYn')"
									:options="useYnList"
								/>
							</td>
						</tr>
						<tr>
							<!--업체담당자-->
							<th class="col-1">* {{ getMessage_('QWCC001593') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input :value="masterInfo.userName" class="inputWithIcon" />
											<i class="icon-sf-search search-icon" @click="() => onUserPopup('userName')"></i>
										</div>
									</el-col>
								</div>
							</td>
							<!--이메일주소-->
							<th class="col-1">* {{ getMessage_('QWCC001161') }}</th>
							<td class="col-1">
								<el-input
									:value="masterInfo.eml"
									type="text"
									placeholder="example@example.com"
									maxlength="60"
									@input="val => onEmailCheck(val, 'eml')"
								/>
							</td>
							<!--연락처-->
							<th class="col-1">* {{ getMessage_('QWCC000061') }}</th>
							<td class="col-1">
								<el-input
									:value="masterInfo.crgrTn"
									type="text"
									maxlength="60"
									:placeholder="this.getMessage_('QWCC001879')"
									@input="val => onChangeSelect(val, 'crgrTn')"
								/>
							</td>
							<!--ssClass-->
							<th class="col-1">* {{ getMessage_('QWCC002091') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:placeholder="this.getMessage_('QWCC002091')"
									:inputValue="masterInfo.ssClass"
									:onChange="val => onChangeSsClass(val, 'ssClass')"
									:options="ssClassList"
								/>
							</td>
							<!--정렬순서-->
							<th class="col-1">{{ getMessage_('QWCC001913') }}</th>
							<td class="col-1">
								<el-input :value="masterInfo.sortNo" maxlength="4" @input="val => onChangeSelect(val, 'sortNo')" />
							</td>
						</tr>
						<tr>
							<!--고객사 제품ID-->
							<th class="col-1">{{ getMessage_('QWCC002048') }}</th>
							<td class="col-1">
								<el-input
									:value="masterInfo.custProdNo"
									maxlength="20"
									@input="val => onChangeSelect(val, 'custProdNo')"
									:readonly="masterInfo.cpnyScn != 20"
								/>
							</td>
							<!--지역-->
							<th class="col-1">{{ getMessage_('QWCC001162') }}</th>
							<td class="col-1">
								<el-input :value="masterInfo.regn" maxlength="66" @input="val => onChangeSelect(val, 'regn')" />
							</td>
							<!--FAX번호-->
							<th class="col-1">{{ getMessage_('QWCC000060') }}</th>
							<td class="col-1">
								<el-input
									:value="masterInfo.fax"
									type="text"
									maxlength="60"
									:placeholder="this.getMessage_('QWCC001879')"
									@input="val => onChangeSelect(val, 'fax')"
								/>
							</td>
							<!--주소-->
							<th class="col-1">{{ getMessage_('QWCC001164') }}</th>
							<td class="col-1" colspan="3">
								<el-input :value="masterInfo.adr" maxlength="333" @input="val => onChangeSelect(val, 'adr')" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!-- popup -->
			<user-popup-view ref="userPopupView" @SendData="sendUserData" :scrId="scrId" />
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import UserPopupView from '@qms/comm/commpopup/UserPopup/UserPopupView.vue';
import * as yup from 'yup';
export default {
	data() {
		return {
			data: '',
			date1: '',
			input1: '',
			pprNo: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	},
	components: { UserPopupView },
	async created() {
		await this.getCommCodes_({ key: 'PartTypeList', codeType: 'PART_G' }); //부품유형
		await this.getCommCodes_({ key: 'cpnyScnList', codeType: 'CPNY_SCN' }); //업체구분
		await this.getCommCodes_({ key: 'ssClassList', codeType: 'SS_CLA' }); //서비스센터
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({
				//다국어 맞게 써주세요.
				// adr: yup //주소
				// 	.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001164')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001164')])),
				// regn: yup //지역
				// 	.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001162')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001162')])),
				// fax: yup //FAX번호
				// 	.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000060')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000060')])),
				crgrTn: yup //연락처
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000061')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000061')])),
				eml: yup //이메일주소
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001161')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001161')])),
				userName: yup //업체담당자
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001593')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001593')])),
				useYn: yup //사용여부
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001163')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001163')])),
				partType: yup //부품유형
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000059')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000059')])),
				cpnyCd: yup //업체코드
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000950')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000950')])),
				cpnyScn: yup //업체구분
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001108')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001108')]))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		//글자수 제한 이벤트
		onChangeSelect(value, key) {
			if (key === 'regn') {
				value = value?.length > 70 ? value.slice(0, 69) : value;
			}
			if (key === 'eml') {
				value = value?.length > 70 ? value.slice(0, 69) : value;
			}
			if (key === 'crgrNm') {
				value = value?.length > 6 ? value.slice(0, 6) : value;
			}
			if (key === 'crgrTn') {
				value = value?.length > 34 ? value.slice(0, 33) : value;
			}
			if (key === 'ssClass') {
				value = value?.length > 10 ? value.slice(0, 9) : value;
			}
			if (key === 'fax') {
				value = value?.length > 34 ? value.slice(0, 33) : value;
			}
			if (key === 'sortNo') {
				value = value.replace(/[^0-9]/g, '');
				value = value?.length > 4 ? value.slice(0, 4) : value;
			}
			this.setCompMstMasterInfo_({ key, value });
		},
		onChangeSsClass(value, key){
			this.onChangeSelect(value, key);
			for (let index = 0; index < this.ssClassList.length; index++) {
				const element = this.ssClassList[index];
				if(value == element.value){
					// console.log('-------',element)
					this.masterInfo.ssClassNm = element.label;
				}
			}
			//console.log(this);
		},
		//이메일 형식 체크 이벤트
		onEmailCheck(value, key) {
			this.setCompMstMasterInfo_({ key, value });
			this.isEmail({ key, value });
		},
		//유저 팝업 메서드
		onUserPopup(userGbn) {
			this.$refs.userPopupView.open({ userGbn, userName: this.searchParams[userGbn + 'Nm'] });
		},
		sendUserData(userData) {
			const { userId, userName, email, mobileNo, fax } = userData;
			// console.log('userData userId, userName, email, mobileNo, fax>>>', userId, userName, email, mobileNo, fax);
			this.setCompMstMasterInfo_({ key: 'crgrNm', value: userId });
			this.setCompMstMasterInfo_({ key: 'userName', value: userName });
			this.setCompMstMasterInfo_({ key: 'eml', value: email });
			this.setCompMstMasterInfo_({ key: 'crgrTn', value: mobileNo });
			this.setCompMstMasterInfo_({ key: 'fax', value: fax });
		},
		//신규버튼 이벤트
		newAction() {
			this.setStateClear_();
			this.setCompMstMasterInfo_({ key: 'cpnyScn', value: '10' });
			this.setCompMstMasterInfo_({ key: 'readOnlyAuth', value: false });
		},
		async saveAction() {
			try {
				const saveParams = this.masterInfo;
				//벨리데이션 체크
				await this.insVali.validateSync(saveParams);
				//협력사만 선택가능하다는 체크
				// if (saveParams.cpnyScn != '10') {
				// 	throw new Error(this.getMessage_('QWCC001934'));
				// }

				if (saveParams.cpnyScn == '90' && saveParams.ssClass == '') {
					throw new Error(this.getMessage_('QWCC002092'));
				}
				//이메일 형식 체크
				if (!this.isEmail(saveParams.eml)) {
					throw new Error(this.getMessage_('QWCC001199'));
				}
				//중복 업체담당자 조회
				await this.getUserName_();
				if (this.getUserNameList.length > 0 && !this.masterInfo.readOnlyAuth) {
					await this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001917') });
				} else {
					//컨펌창.
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
						buttons: [{ title: this.getMessage_('SWCC000278'), clickFn: this.save }] //저장
					});
				}
				// if (!this.isNumber(saveParams.crgrTn)) {
				// 	throw new Error(this.getMessage_('QWCC001200'));
				// }
				// if (!this.isNumber(saveParams.fax)) {
				// 	throw new Error(this.getMessage_('QWCC001201'));
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		isEmail(asValue) {
			const regExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
			return regExp.test(asValue);
		},
		async save() {
			this.$sf_toggleLoading(true);

			const saveParams = this.masterInfo;

			const params = { saveParams: saveParams };

			await this.saveCompMst_(params)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$emit('Refresh');
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
